import { ComponentProps } from "react";

import { SPRITE_SYMBOLS } from "@/assets/icons/sprite/IconSprite";
import { SpriteIcon } from "@/assets/icons/sprite/SpriteIcon";

/* Sprite-backed: product-card and filter chevrons: 22-25 per category page; the path lives in `IconSprite`. */
export const IconNavigationChevronDown = (props: ComponentProps<"svg">) => (
  <SpriteIcon
    symbol={SPRITE_SYMBOLS.navChevronDown}
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    {...props}
  />
);
